<template>
	<div>
		<div class="bg-top">
	      <div class="container text-center font-30">
	        <router-link class="text-white" to="/">
	          {{status == 'mentor' ? 'GreatGrowth' : 'Tickets'}}
	        </router-link>
	      </div>
	    </div>
	    <div class="container">
	    	<form @submit.prevent="submit()" class="box-page border rounded mt-5 p-4 col-8 mx-auto" >
				<div class="text-center font-weight-bold mt-3">
					<h4>Sign in</h4>
				</div>
				<div v-if="loginError" class="alert alert-danger text-center" role="alert" :class="{'shake animated': animated}">
		          {{textError}}
		        </div>
		        <div class="form-group">
		        	<label>E-mail</label>
		            <input
		                id="input-email"
		                type="email"
		                required
		                class="form-control"
		                v-model="login.email"
		                placeholder="example@gmail.com"
		            >
		        </div>
		        <div class="form-group">
		        	<label>Password</label>
		            <input
		                id="input-password"
		                type="password"
		                required
		                class="form-control"
		                 v-model="login.password"
		                placeholder="Password"
		            >
		        </div>
		        <div>
		        	<button type="submit" class="mb-3 w-100 btn text-white btn-greatgrowth d-block font-weight-bold">
			            SIGN IN
			        </button>
		        </div> 
	    	</form>
	    </div>
	</div>
</template>
<script>
import {HTTPReview} from "@/axios.js";
	export default{
		data () {
		    return {
		    textError:'',
		      loading:false,
		      status:this.$route.params.status,
		      login:{
		          email:'',
		          password:'',
		      },
		      loginError:false,
		      mentor:{
		          email:'',
		          password:'',
		      },
			  signinmentor:false,
			  animated: false,
		    }
		},
		methods:{
			submit(){
				let data ={
					email:this.login.email,
					password:this.login.password,
					projectCode:this.status == 'mentor' ? "oZcIppU-VBIx9KO" : "01Is8FN-ikyRCrC",
					redirectUrl:""
				}
				console.log('data',data)
				HTTPReview.post('/api/sign/in/export',data).then(res =>{
					console.log('opoalsdklsadmksadkasjkd',res)
					if(res.data.success){
						this.$store.commit('setUser',res.data.obj.objUser)
						let data ={
							key:'token',
							value:res.data.tokenAuth
						}
						this.$store.commit('updateUser',data)
						// let status ={
						// 	key:'typeSystem',
						// 	value:this.status
						// }
						// this.$store.commit('updateUser',status)
						this.$router.push('/review-list')
					}else{
						if(res.data.data == "user is not access."){
							this.textError = "Sorry for your inconvenience :( We're not allowed mentor access to this page."
						}else{
							this.textError = "Invalid E-mail or password"
						}
						
						this.animated = true
						setTimeout(() => {
							this.animated = false
						},1000)
						this.loginError = true
	                    setTimeout(()=>{
	                      this.loginError = false
	                    },5000)
					}
					
				})
			}
		}
	}
</script>

<style scoped>
	.signinmentor{
		padding: 30px;
	}
	.bg-top{
		padding:15px 0;
		color:#fff;
		background-color: rgb(13, 106, 202) !important;
	}
</style>